__turbopack_context__.v({
  "className": "dancing_script_f1f968e1-module__6Qcj6G__className",
});
